(function(document, tag) {
	var script = document.createElement(tag);
	var element = document.getElementsByTagName('body')[0];
	script.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; script.async = true; script.defer = true;
	(typeof element === 'undefined' ? document.getElementsByTagName('html')[0] : element).appendChild(script);
	script.onload = function() {
    acsbJS.init({
        statementLink		: 'https://www.tastycloudvapeco.com/pages/accessibility-statement',
		feedbackLink		: '',
      footerHtml			: '<span data-acsb-popup-trigger="acsb-hide-popup" style="padding:10px 0;font-weight:bold;">Disable Accessibility Options</span>', 
        hideMobile			: false,
        hideTrigger			: false,
        language			: 'en',
        position			: 'right',
        leadColor			: '#146FF8',
        triggerColor		: '#146FF8',
        triggerRadius		: '0',
        triggerPositionX	: 'right',
        triggerPositionY	: 'bottom',
        triggerIcon			: 'default',
        triggerSize			: 'small',
        triggerOffsetX		: 0,
        triggerOffsetY		: 0, 
        mobile: { 
          triggerSize		: 'small',
          triggerPositionX	: 'right',
          triggerPositionY	: 'bottom', 
          triggerOffsetX	: 0,
          triggerOffsetY	: 0,
          triggerRadius		: '0'
		}
	  });
	};
}(document, 'script'));